export default __webpack_public_path__ + "static/media/figure_esn.9f56602f.png";